import { Dispatch, SetStateAction } from 'react';

export const replaceItemInArray = <T extends Record<string, unknown>>(
  data: T[],
  newData: T,
) => {
  const copiedData = [...data];
  const index = copiedData.findIndex((oldRowData) => newData.id === oldRowData.id);

  if (index > -1) {
    copiedData.splice(index, 1, newData);
  }

  return copiedData;
};

export const replaceItemInArrayWithState = <T extends Record<string, unknown>>(
  newData: T,
  setState: Dispatch<SetStateAction<T[] | undefined>>,
) => {
  setState((prevState = []) => replaceItemInArray(prevState, newData));
};

export const removeItemFromArray = <T extends Record<string, unknown>>({
  key = 'id',
  value = 0,
  data,
}: {
  data: T[];
  key?: string;
  value?: number;
}) => data.filter((record) => record[key] !== value);

export const removeItemFromArrayWithState = <T extends Record<string, unknown>>({
  key = 'id',
  value = 0,
  setState,
}: {
  key?: string;
  value?: number;
  setState: Dispatch<SetStateAction<T[] | undefined>>;
}) => {
  setState((prevState = []) => removeItemFromArray({ key, value, data: prevState }));
};

export const pushItemInArrayWithState = <T extends Record<string, unknown>>(
  newData: T,
  setState: Dispatch<SetStateAction<T[] | undefined>>,
) => {
  setState((prevState = []) => [...prevState, newData]);
};
